// SISTRIX-Onpage im SEO-Tab: Crawler-Fehler/Warnungen/Hinweise je Portal (rot/gelb/blau)
// + aufklappbare Detail-Listen der roten & gelben Befunde + Claude-Priorisierung.
import type { MarketingDeps } from "./marketing.js";

interface Issue { name: string; label: string; count: number; type: string }
interface Portal {
  name: string; date: string | null;
  error_count: number; warning_count: number; notice_count: number;
  errors: Issue[]; warnings: Issue[];
}
interface SistrixSummary {
  empty?: boolean; generated_at?: string; report_at?: string;
  portals?: Portal[]; insight?: { summary: string; recommendations: string[] } | null;
}

function el(tag: string, cls?: string, text?: string): HTMLElement {
  const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e;
}

export function initSistrixSeo(m: HTMLElement, deps: MarketingDeps): void {
  const host = m.querySelector("[data-sistrix]") as HTMLElement | null;
  const msg = m.querySelector('[data-msg="sistrix"]') as HTMLElement | null;
  if (!host) return;

  const load = async (): Promise<void> => {
    host.innerHTML = '<p class="dim">Lade …</p>';
    const r = await deps.api<SistrixSummary>("/api/marketing/sistrix");
    const d = r.data;
    if (!d || d.empty) {
      host.innerHTML = '<p class="dim">Noch keine SISTRIX-Onpage-Daten. Über „↻ Crawl-Ergebnisse abholen“ laden.</p>';
      return;
    }
    host.textContent = "";

    const when = d.report_at || d.generated_at;
    if (when) host.appendChild(el("p", "dim", "Stand " + new Date(when).toLocaleDateString("de-DE", { day: "2-digit", month: "long", year: "numeric" })));

    // Insight (aufklappbar)
    if (d.insight) {
      const det = document.createElement("details"); det.className = "perf-insight"; det.open = true;
      const sum = document.createElement("summary");
      sum.appendChild(el("span", "perf-insight__title", "💡 Priorisierung"));
      const rc = d.insight.recommendations?.length ?? 0;
      sum.appendChild(el("span", "perf-insight__hint", rc ? `${rc} Punkte` : "ansehen"));
      det.appendChild(sum);
      const body = el("div", "perf-insight__body");
      body.appendChild(el("p", undefined, d.insight.summary));
      if (rc) { const ul = document.createElement("ul"); for (const rec of d.insight.recommendations) ul.appendChild(el("li", undefined, rec)); body.appendChild(ul); }
      det.appendChild(body);
      host.appendChild(det);
    }

    // Übersichtstabelle
    const t = document.createElement("table"); t.className = "om-table";
    const hr = t.createTHead().insertRow();
    for (const h of ["Portal", "🔴 Fehler", "🟡 Warnungen", "🔵 Hinweise", "Crawl"]) hr.appendChild(el("th", undefined, h));
    const tb = t.createTBody();
    for (const p of d.portals ?? []) {
      const tr = tb.insertRow();
      tr.insertCell().textContent = p.name;
      tr.insertCell().textContent = String(p.error_count);
      tr.insertCell().textContent = String(p.warning_count);
      tr.insertCell().textContent = String(p.notice_count);
      tr.insertCell().textContent = p.date ?? "—";
    }
    host.appendChild(t);

    // Detail je Portal (nur rot+gelb, aufklappbar)
    for (const p of d.portals ?? []) {
      if (!p.errors.length && !p.warnings.length) continue;
      const det = document.createElement("details"); det.className = "om-sistrix-portal";
      const sum = document.createElement("summary");
      sum.textContent = `${p.name} — ${p.error_count} Fehler · ${p.warning_count} Warnungen`;
      det.appendChild(sum);
      const ul = el("ul", "om-sistrix-issues");
      for (const e of p.errors) ul.appendChild(el("li", "sev-error", `🔴 ${e.label} — ${e.count}`));
      for (const w of p.warnings) ul.appendChild(el("li", "sev-warn", `🟡 ${w.label} — ${w.count}`));
      det.appendChild(ul);
      host.appendChild(det);
    }
  };

  m.querySelector('[data-action="run-sistrix"]')?.addEventListener("click", () => {
    void (async () => {
      if (msg) msg.textContent = "Starte SISTRIX-Crawl-Pull …";
      const r = await deps.api<{ stamp?: string }>("/api/marketing/motors/sistrix_onpage/run", "POST");
      if (msg) msg.textContent = r.status === 200 ? "Läuft — in ~30 Sek neu öffnen." : r.status === 409 ? "Läuft bereits." : `Fehler (${r.status})`;
    })();
  });

  void load();
}
